import React, { useState, useRef } from 'react';
import {
  Box,
  Button,
  IconButton,
  Typography,
  Paper,
  Avatar,
} from '@mui/material';
import {
  CloudUpload as CloudUploadIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
} from '@mui/icons-material';

const IconUpload = ({ icon = null, onIconChange, title = "Icône" }) => {
  const [dragActive, setDragActive] = useState(false);
  const fileInputRef = useRef(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const handleFile = (file) => {
    const iconData = {
      id: Date.now() + Math.random(),
      file,
      preview: URL.createObjectURL(file),
      name: file.name,
    };
    onIconChange(iconData);
  };

  const handleFileSelect = (e) => {
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files[0]);
    }
  };

  const removeIcon = () => {
    onIconChange(null);
  };

  const openFileDialog = () => {
    fileInputRef.current?.click();
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileSelect}
        style={{ display: 'none' }}
      />

      {/* Zone de drop */}
              <Paper
          sx={{
            border: '2px dashed',
            borderColor: dragActive ? 'primary.main' : 'grey.600',
            borderRadius: 2,
            p: 3,
            textAlign: 'center',
            backgroundColor: dragActive ? 'rgba(144, 202, 249, 0.1)' : 'background.paper',
            cursor: 'pointer',
            mb: 2,
          }}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
        onClick={openFileDialog}
      >
        <CloudUploadIcon sx={{ fontSize: 48, color: 'grey.400', mb: 2 }} />
        <Typography variant="h6" color="textSecondary" gutterBottom>
          Glissez-déposez votre icône ici
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          ou cliquez pour sélectionner un fichier
        </Typography>
        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          sx={{ mt: 2 }}
          onClick={(e) => {
            e.stopPropagation();
            openFileDialog();
          }}
        >
          Ajouter une icône
        </Button>
        <Typography variant="caption" color="textSecondary" display="block" sx={{ mt: 1 }}>
          Formats acceptés: JPG, PNG, GIF • Taille recommandée: 64x64px
        </Typography>
      </Paper>

      {/* Prévisualisation de l'icône */}
      {icon && (
        <Box>
          <Typography variant="subtitle1" gutterBottom>
            Icône sélectionnée
          </Typography>
          <Paper
            sx={{
              position: 'relative',
              overflow: 'hidden',
              borderRadius: 2,
              display: 'inline-block',
            }}
          >
            <Avatar
              src={icon.preview}
              alt={icon.name}
              sx={{
                width: 80,
                height: 80,
                objectFit: 'cover',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                top: 4,
                right: 4,
                backgroundColor: 'rgba(0,0,0,0.5)',
                borderRadius: '50%',
              }}
            >
              <IconButton
                size="small"
                onClick={removeIcon}
                sx={{ color: 'white' }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Box>
          </Paper>
          <Typography variant="caption" display="block" sx={{ mt: 1 }}>
            {icon.name}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default IconUpload;
